/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import moment from 'moment';

import { useHistory, useParams } from 'react-router-dom';
import { cell_t, project_t } from '../../logic/types';
import './project-cell.scss';
import { projectDetailsData, projectDetailsStore } from '../../stores/projectDetailsStore';
import { projectsData, projectsStore } from '../../stores/projectsStore';
import { ModalComponent } from '@eyesee/eyesee-hub-npm-ui';
import DeleteModal from '../DeleteModal/DeleteModal';
import { observer } from 'mobx-react-lite';

const ProjectCell = observer(
    ({
        cell,
        project,
        previewLink,
        showDropdown,
        handleCSVDropdownClick,
        closeAllCSVPreviews,
    }: {
        cell: cell_t;
        project: project_t;
        previewLink: (e: React.MouseEvent<HTMLElement, MouseEvent>, link: string) => void;
        showDropdown: any;
        handleCSVDropdownClick: Function;
        closeAllCSVPreviews: Function;
    }) => {
        const history = useHistory();
        const { project_id } = useParams();
        let link = `${process.env.REACT_APP_API_URL}tests?cell=${cell.name}&project=${project.name}&userid=${(Math.random() + 1)
            .toString(36)
            .substring(7)}`;

        const handleCellClick = () => {
            if (!projectDetailsData.isDataSaved) {
                if (!window.confirm('Are you sure you want to leave without saving your work?')) {
                    return;
                } else {
                    redirectToCell();
                }
            } else {
                redirectToCell();
            }
        };

        const redirectToCell = () => {
            projectDetailsData.cellId = cell.id;
            projectDetailsData.isDataSaved = true;
            history.push(`/projects/${project_id || 'new-project'}/cell${cell.id}`);
        };

        const onDeleteCell = (e: React.MouseEvent<HTMLElement, MouseEvent>, id: string) => {
            e.stopPropagation();
            projectsData.isModalVisible = true;
            projectsData.modalData = id;
        };

        const deleteCellFromProject = (cellId: any) => {
            projectDetailsStore.deleteCell(cellId);
            projectsStore.hideModal();
        };

        const goToPreview = (e: React.MouseEvent<HTMLElement, MouseEvent>, isPremium: boolean, isCSV: boolean) => {
            e.preventDefault();
            e.stopPropagation();

            let link = `${process.env.REACT_APP_API_URL}results/exportResultsForCell?project_id=${project.id}&cell_id=${cell.id}&is_premium=${isPremium}`
            if (isCSV) {
                link = `${link}&csv_download=true`
            }

            const win = window.open(link, '_blank');
            win?.focus();
        };

        return (
            <div className="cell-box" onClick={handleCellClick}>
                <ModalComponent
                    hide={() => (projectsData.isModalVisible = false)}
                    component={
                        <DeleteModal
                            confirmFN={() => deleteCellFromProject(projectsData.modalData)}
                            hideModal={projectsStore.hideModal}
                            headerText={'Delete Task'}
                            contentText={'You are about to delete a cell from project. Are you sure? '}
                            confirmButtonText={'Delete'}
                        />
                    }
                    isVisible={projectsData.isModalVisible}
                />

                <span>{cell.name}</span>
                <span>{project.name}</span>
                <span>{moment(cell.end_date).format('DD.MM.YYYY.')}</span>
                <div className="cell-icons-wrapper">
                    <i
                        className="material-icons link indigo-text text-lighten-1"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            projectDetailsStore.duplicateCell(cell.id);
                        }}
                        title="Duplicate"
                    >
                        file_copy
                    </i>
                    <i
                        className="material-icons link"
                        title="Link"
                        onClick={(e) => {
                            closeAllCSVPreviews();
                            previewLink(e, link);
                        }}
                    >
                        link
                    </i>
                    <span className="cell-box__results">
                        {' '}
                        <i className="material-icons link" title="CSV Preview" onClick={(e) => handleCSVDropdownClick(e, cell.id)}>
                            get_app
                        </i>
                        {showDropdown[cell.id] && (
                            <span className="cell-box__results__dropdown">
                                <a href="#" onClick={(e) => goToPreview(e, false, false)}>
                                    Preview results
                                </a>
                                <a href="#" onClick={(e) => goToPreview(e, true, false)}>
                                    Preview premium results
                                </a>
                                <a href="#" onClick={(e) => goToPreview(e, false, true)}>
                                    Download CSV results
                                </a>
                            </span>
                        )}
                    </span>
                    <i className="material-icons link red-text text-lighten-1" onClick={(e) => onDeleteCell(e, cell.id)} title="Delete">
                        delete
                    </i>{' '}
                </div>
            </div>
        );
    }
);
export default ProjectCell;
